<style lang="scss" scoped>
  	.pumping-card-friend {
		width: 100%;
		height: auto;
		overflow: auto;
		overflow-x: hidden;
		text-align: center;
	}
	.card-list-animate-slow {
		animation:animation2 100s linear infinite;
	}
	@keyframes animation2 {
		0%{ transform: rotate(0deg); }
		100%{ transform: rotate(360deg); }
	}
	.card-list-animate {
		animation:animation1 6s linear infinite;
	}
	@keyframes animation1 {
		0%{ transform: rotate(0deg); }
		20%{ transform: rotate(90deg); }
		40%{ transform: rotate(180deg); }
		70%{ transform: rotate(240deg); }
		80%{ transform: rotate(280deg); }
		85%{ transform: rotate(300deg); }
		90%{ transform: rotate(320deg); }
		95%{ transform: rotate(340deg); }
		96%{ transform: rotate(348deg); }
		98%{ transform: rotate(356deg); }
		100%{ transform: rotate(360deg); }
	}
	.slide-fade-enter-active {
		transition: all 1s ease;
	}
	.slide-fade-enter {
		transform: rotateY(180deg);
	}
	@media (min-width:800px) {
		.pumping-card-friend {
			background: url("../../assets/appointment/pumping-friend-bg-pc.png") no-repeat center;
			background-size: 100% 100%;
		}
		.top {
			position: relative;
			width: 1661px;
			height: 900px;
			margin: 0 auto;
			background: url("../../assets/appointment/pumping-top-bg-pc.png") no-repeat center;
			text-align: center;
			.card-list {
				position: absolute;
				top: -830px;
				left: 0;
				right: 0;
				margin: 0 auto;
				width: 1660px;
				height: 1660px;
				.card-block {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					margin: 0 auto;
					width: 230px;
					height: 830px;
					transform-origin:50% 100%;
					.card {
						transform: rotate(180deg);
						width: 100%;
						height: auto;
					}
				}
			}
		}
		.pump-btn {
			margin-top: 80px;
			margin-left: 125px;
			margin-right: 125px;
			cursor: pointer;
		}
		.tip {
			color: #7a6890;
			font-size: 28px;
			font-weight: bold;
			letter-spacing: 8px;
			line-height: 90px;
			margin-bottom: 20px;
		}
		.rule {
			width: 1060px;
			height: auto;
			overflow: auto;
			margin: 0 auto 30px auto;
			text-align: left;
			color: #7a6890;
			font-size: 20px;
			line-height: 34px;
			font-weight: bold;
		}
		.footer {
			position: relative;
			width: 100%;
			height: 388px;
			background: url('../../assets/appointment/pc/footer-bg.png');
			text-align: center;
			color: #f4ebe5;
			font-size: 20px;
			line-height: 32px;
			padding-top: 165px;
			.footer-logo {
				position: absolute;
				top: 10px;
				left: 16%;
			}
			.footer-icon {
				margin-top: 25px;
				margin-bottom: 10px;
			}
		}
		.card-modal {
			position: relative;
			width: 735px;
			height: 655px;
			background: url("../../assets/appointment/card-show-bg1.png");
			text-align: center;
			.hide-btn {
				position: absolute;
				top: 0;
				right: 0;
				cursor: pointer;
			}
			.icon {
				margin-top: 55px;
			}
			.btn {
				margin-top: 20px;
				margin-left: 40px;
				margin-right: 40px;
			}
			.ct {
				width: 250px;
			}
		}
	}
	@media (max-width:800px) {
		.pumping-card-friend {
			background: url("../../assets/appointment/pumping-friend-bg-mobile.png") no-repeat center;
			background-size: 100% 100%;
		}
		.top {
			position: relative;
			width: 100%;
			height: 530px;
			background: url("../../assets/appointment/pumping-top-bg-mobile.png") no-repeat center;
			background-size: 100% 100%;
			text-align: center;
			.pumping-logo {
				width: 36%;
    			margin-top: 4vh;
			}
			.card-list {
				position: absolute;
				top: -500px;
				left: 0;
				right: 0;
				margin: 0 auto;
				width: 375px;
				height: 1000px;
				.card-block {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					margin: 0 auto;
					width: 150px;
					height: 500px;
					transform-origin:50% 100%;
					.card {
						transform: rotate(180deg);
						width: 100%;
						height: auto;
					}
				}
			}
		}
		.pump-btn {
			height: 5vh;
			width: auto;
			margin-left: 6%;
			margin-right: 6%;
			margin-top: 5vh;
		}
		.tip {
			color: #7a6890;
			font-size: 14px;
			font-weight: bold;
			letter-spacing: 2px;
			line-height: 18px;
			margin-top: 5px;
			margin-bottom: 40px;
			padding-left: 3%;
			padding-right: 3%;
		}
		.rule {
			width: 100%;
			height: auto;
			overflow: auto;
			padding-left: 3%;
			padding-right: 3%;
			text-align: left;
			color: #7a6890;
			font-size: 14px;
			line-height: 24px;
			font-weight: bold;
		}
		.footer {
			position: relative;
			width: 100%;
			height: 28vh;
			background: url('../../assets/appointment/mobile/footer-bg.png');
			background-size: 100% 100%;
			text-align: center;
			color: #f4ebe5;
			font-size: 12px;
			line-height: 18px;
			.footer-logo {
				position: absolute;
				top: 23px;
				left: 15%;
				width: 10vh;
			}
			.footer-icon {
				margin-top: 10.5vh;
				margin-bottom: 1vh;
				width: 30%;
			}
			.word {
				transform: scale(0.9);
			}
		}
		.card-modal {
			position: relative;
			width: 98%;
			height: 60vh;
			background: url("../../assets/appointment/card-show-bg1.png");
			background-size: 100% 100%;
			text-align: center;
			.hide-btn {
				position: absolute;
				top: 0;
				right: 0;
				width: 30px;
			}
			.icon {
				width: 40%;
				margin-top: 55px;
			}
			.btn {
				height: 4vh;
				margin-top: 20px;
			}
			.ct {
				width: 22vh;
				margin-left: 2%;
				margin-right: 2%;
			}
		}
	}
	.game-frame {
		position: fixed;
		z-index: 99;
		top: 15%;
		right: 5%;
		width: 70px;
		height: 80px;
		background: url("../../assets/appointment/suspended-frame1.png");
		background-size: 100% 100%;
		text-align: center;
		cursor: pointer;
		.item {
			line-height: 40px;
			font-size: 14px;
		}
	}
</style>

<template>
  	<div class="pumping-card-friend">
	  	<!-- 返回悬浮框 -->
		<div class="game-frame">
			<div @click="goIndex" class="item">返回首页</div>
			<div class="item">
				<a style="color: #515a6e;" href="http://uri6.com/tkio/FNJNrea">立即下载</a>
			</div>
		</div>
		<!-- 头部 -->
		<div class="top">
			<img class="pumping-logo" src="../../assets/appointment/pumping-logo.png" alt="">
			<div :class="['card-list', {'card-list-animate': cardAnimateShow}, {'card-list-animate-slow': !cardAnimateShow}]">
				<div v-for="(item, index) in cardShowList" :key="item.id" :style="{'transform': 'rotate('+ index*30 +'deg)'}" class="card-block">
					<img class="card" :src="item.filePath" :alt="item.fileName">
				</div>
			</div>
		</div>
		<!-- 抽卡按钮 -->
		<img @click="getCard" class="pump-btn" src="../../assets/appointment/pump-btn3.png" alt="帮好友抽">
		<img @click="goPumpCard" class="pump-btn" src="../../assets/appointment/pump-btn4.png" alt="自己抽">
		<!-- 提示 -->
		<div class="tip">预约后每天可获得3次预抽卡机会</div>
		<!-- 规则 -->
		<div class="rule">
			<div class="part">活动简介：在游戏上线前，预约成功的玩家可以在活动页面进行多次抽卡，并可最终选择一位心仪的伙伴作为初始伙伴。</div>
			<div class="part">活动时间：截止时间1月15日。</div>
			<div class="part">
				<span>活动规则：</span><br>
				<span>1、成功预约游戏的用户，每日登录官网即可获取3次抽卡机会，未使用次数不可累计。次日0点刷新重置次数。</span><br>
				<span>2、可分享好友帮你抽取伙伴，每位好友每天最多可抽一次，每天最多可邀请三位好友帮抽，次日0点刷新重置次数。</span><br>
				<span>3、每次仅可保留一位伙伴，新卡替换旧卡操作无法逆转，请慎重选择。最多可以保存一张伙伴直至预抽卡活动结束。</span><br>
				<span>4、活动结束后，最后保留的伙伴将发放至「用预约手机绑定的游戏账号」内，请登录新服领取。</span><br>
			</div>
			<div class="part">*每个预约手机号仅可获得一次奖励；每个游戏账号只能领取一次奖励，改绑手机号无效。*</div>
		</div>
		<!-- footer -->
		<div class="footer">
			<img class="footer-logo" src="../../assets/appointment/pc/footer-logo.png" alt="">
			<img class="footer-icon" src="../../assets/appointment/pc/footer-icon.png" alt="">
			<div class="word">
				<span style="margin-right: 10px;">家长监护</span>
				<span>适龄提示：本游戏适合18岁（含）以上玩家娱乐</span>
			</div>
			<div class="word">
				<span>互联网ICP备案：<a @click="goPage">沪ICP备13003575-1号</a> | 上海掌梦网络科技有限公司</span>
			</div>
			<div class="word">
				<span>沪公网安备 31011502017186号 | 上海掌梦网络科技有限公司</span>
			</div>
			<div class="word">
				<span style="margin-right: 10px;">地址：上海市浦东新区乳山路233号德必WE402</span>
				<span>客服电话：021-58385528</span>
			</div>
		</div>
		<!-- 卡牌弹窗 -->
		<div v-show="cardModalShow" class="modal-block">
			<div class="card-modal">
				<img @click="cardModalShow=false" class="hide-btn" src="../../assets/appointment/back-icon1.png" alt="">
				<img class="icon" src="../../assets/appointment/card-show-icon1.png" alt=""><br>
				<img class="ct" :src="cardGet.filePath" :alt="cardGet.fileName"><br>
				<a :href="cardGet.filePath">
					<img class="btn" src="../../assets/appointment/down-local-btn.png" alt="">
				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'friend',
	data() {
		return {
			phoneNumber: '',
			cardShowList: [],
			cardModalShow: false,
			cardAnimateShow: false,
			cardGet: {
				fileName: '',
				filePath: ''
			},
		}
	},
	mounted() {
		this.phoneNumber = this.$route.query.phone;
		this.initData();
	},
	methods: {
		goIndex() {
			this.$router.push({name: 'appoint-home-pc'});
		},
		initData() {
			this.$http.get('/api/subscribe/initFriendThatCards').then(res => {
				this.cardShowList = res.result.sevenImage;
			});
		},
		getCard() {
			if(!this.phoneNumber || this.phoneNumber.length != 11) {
				this.$Message.warning("请保证帮抽链接完整！");
			} else {
				this.cardAnimateShow = true;
				let time = setTimeout(() =>{
					clearTimeout(time);
					this.cardAnimateShow = false;
					this.$http.get('/api/subscribe/thatCard?phone=' + this.phoneNumber + '&type=2').then(res => {
						this.cardModalShow = true;
						this.cardGet = res.result.card;
					});
				}, 4000);
			}
		},
		goPumpCard() {
			this.$router.push({name: 'a-index'});
		},
		goPage() {
			window.open('https://beian.miit.gov.cn/', '_blank')
		}
	}
}
</script>
